var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loading
    ? _c("Loading")
    : _c(
        "Box",
        { staticClass: "invoice-container", attrs: { display: "flex" } },
        [
          _c(
            "Card",
            { staticClass: "invoice", attrs: { flex: 2 } },
            [
              _c(
                "Box",
                {
                  attrs: {
                    tag: "header",
                    display: "flex",
                    marginBottom: 9,
                    flexAlign: "center"
                  }
                },
                [
                  _c(
                    "Box",
                    { staticClass: "details" },
                    [
                      _c("layoutText", [_vm._v("July 24th, 2019")]),
                      _c("br"),
                      _c("layoutText", [_vm._v("John Smith")]),
                      _c("layoutText", [_vm._v("11 Broadway")]),
                      _c("layoutText", [_vm._v("New York, NY 10004")])
                    ],
                    1
                  ),
                  _c(
                    "Box",
                    { staticClass: "logo" },
                    [
                      !_vm.state.logoFile.file
                        ? _c("Box", [
                            _c("img", {
                              attrs: {
                                src:
                                  "https://res.cloudinary.com/orthodox-union/image/upload/v1575887944/logo-placeholder_lvxriu.jpg",
                                alt: "Logo"
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm.campaignId
                        ? _c(
                            "Box",
                            [
                              _vm.state.logoFile.status === "failed"
                                ? _c("div", { staticClass: "logo-error" }, [
                                    _vm._v("Error uploading file")
                                  ])
                                : _vm._e(),
                              _vm.state.logoFile.file
                                ? _c(
                                    "Box",
                                    { staticClass: "image-box" },
                                    [
                                      _c("GetSignedUrl", {
                                        attrs: {
                                          filename: _vm.state.logoFile.file
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function({ url }) {
                                                return [
                                                  _c("img", {
                                                    attrs: { src: url }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          478566660
                                        )
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("S3Uploader", {
                                attrs: { location: "logo" },
                                on: {
                                  input: function($event) {
                                    return _vm.onLogoChanged($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "Box",
                { staticClass: "main-text" },
                [
                  _c(
                    "layoutFormRow",
                    [
                      _c(
                        "Box",
                        { attrs: { flex: 1 } },
                        [
                          _c("UILabel", { attrs: { text: "Template Name" } }),
                          _c("FancySelect", {
                            attrs: {
                              clearable: false,
                              options: _vm.nameOptions
                            },
                            model: {
                              value: _vm.state.templateNameValue,
                              callback: function($$v) {
                                _vm.$set(_vm.state, "templateNameValue", $$v)
                              },
                              expression: "state.templateNameValue"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "layoutFormRow",
                    [
                      _c(
                        "Box",
                        { attrs: { flex: 1 } },
                        [
                          _c("UILabel", { attrs: { text: "First line" } }),
                          _c("UIInput", {
                            model: {
                              value: _vm.state.firstLine,
                              callback: function($$v) {
                                _vm.$set(_vm.state, "firstLine", $$v)
                              },
                              expression: "state.firstLine"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "layoutFormRow",
                    [
                      _c(
                        "Box",
                        { attrs: { flex: 1 } },
                        [
                          _c("WysiwygEditor", {
                            attrs: {
                              placeholder: "Enter the text here",
                              toolbarExtras: _vm.toolbarExtras
                            },
                            model: {
                              value: _vm.state.body,
                              callback: function($$v) {
                                _vm.$set(_vm.state, "body", $$v)
                              },
                              expression: "state.body"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "layoutFormRow",
                    [
                      _c(
                        "Box",
                        { attrs: { flex: 1 } },
                        [
                          _c("UILabel", { attrs: { text: "Check Notes" } }),
                          _c("WysiwygEditor", {
                            attrs: {
                              placeholder: "Enter the text here",
                              toolbarExtras: _vm.toolbarExtras
                            },
                            model: {
                              value: _vm.state.paymentNotes,
                              callback: function($$v) {
                                _vm.$set(_vm.state, "paymentNotes", $$v)
                              },
                              expression: "state.paymentNotes"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.department
                    ? _c(
                        "layoutFormRow",
                        [
                          _c(
                            "Box",
                            { attrs: { flex: 1 } },
                            [
                              _c("UILabel", {
                                attrs: { text: "Donation Form URL" }
                              }),
                              _c("UIInput", {
                                model: {
                                  value: _vm.state.donationFormUrl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.state, "donationFormUrl", $$v)
                                  },
                                  expression: "state.donationFormUrl"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "layoutFormRow",
                    [
                      _c(
                        "Box",
                        { attrs: { flex: 1 } },
                        [
                          _c("UILabel", { attrs: { text: "Email Text" } }),
                          _c("WysiwygEditor", {
                            attrs: {
                              placeholder: "Enter the text here",
                              toolbarExtras: _vm.toolbarExtras
                            },
                            model: {
                              value: _vm.state.emailText,
                              callback: function($$v) {
                                _vm.$set(_vm.state, "emailText", $$v)
                              },
                              expression: "state.emailText"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.campaignId || _vm.department
                    ? _c(
                        "layoutFormRow",
                        [
                          _c("UILabel", {
                            attrs: { text: "Remove Signature from Email:" }
                          }),
                          _c("UICheckbox", {
                            staticStyle: { "margin-left": "10px" },
                            model: {
                              value: _vm.state.removeSignature,
                              callback: function($$v) {
                                _vm.$set(_vm.state, "removeSignature", $$v)
                              },
                              expression: "state.removeSignature"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.department || _vm.campaignId
                    ? _c(
                        "layoutFormRow",
                        [
                          _c(
                            "Box",
                            { attrs: { flex: "1" } },
                            [
                              _c("UILabel", {
                                attrs: { text: "Salutation", for: "salutation" }
                              }),
                              _c(
                                "RadioGroup",
                                {
                                  model: {
                                    value: _vm.state.salutationType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.state, "salutationType", $$v)
                                    },
                                    expression: "state.salutationType"
                                  }
                                },
                                _vm._l(_vm.salutations, function(salutation) {
                                  return _c("RadioGroupItem", {
                                    key: salutation.value,
                                    attrs: { value: salutation.value },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ props, listeners }) {
                                            return [
                                              _c(
                                                "UIRadio",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        labelText:
                                                          salutation.label
                                                      }
                                                    },
                                                    "UIRadio",
                                                    props,
                                                    false
                                                  ),
                                                  listeners
                                                )
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "UIButton",
                    {
                      staticClass: "blue",
                      attrs: {
                        size: "2",
                        inverted: "true",
                        disabled: !_vm.dirty
                      },
                      on: {
                        click: function($event) {
                          return _vm.saveTemplate()
                        }
                      }
                    },
                    [
                      _c(
                        "layoutText",
                        { attrs: { size: "4" } },
                        [
                          _vm._v(" Save "),
                          _vm.dirty ? [_vm._v("*")] : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("Box", { staticClass: "signature" }, [
                _vm._v(" Sincerely, "),
                _c("br"),
                _c("img", {
                  staticClass: "signature-img",
                  attrs: {
                    src:
                      "https://res.cloudinary.com/orthodox-union/image/upload/v1557784529/jlic/Rabbi-Pinny-Rosenthal-Signature.jpg"
                  }
                }),
                _c("br"),
                _vm._v("FirstName LastName "),
                _c("br"),
                _vm._v("Position ")
              ]),
              _c(
                "Box",
                { staticClass: "return-portion" },
                [
                  _c(
                    "Box",
                    { attrs: { tag: "header" } },
                    [
                      _c(
                        "layoutText",
                        {
                          staticClass: "text-center",
                          attrs: {
                            fontSize: 2,
                            color: "#222",
                            fontWeight: "bold"
                          }
                        },
                        [
                          _vm._v(
                            "Please return the portion below with your payment and your name and address showing"
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "Box",
                    { staticClass: "details" },
                    [
                      _c("layoutText", { attrs: { fontSize: 1 } }, [
                        _vm._v("Dr. Bruce Banner")
                      ]),
                      _c("layoutText", { attrs: { fontSize: 1 } }, [
                        _vm._v("5565 Melrose Drive")
                      ]),
                      _c("layoutText", { attrs: { fontSize: 1 } }, [
                        _vm._v("New York, NY 44763")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "UITable",
                    { staticClass: "small return-table" },
                    [
                      _c(
                        "TableHead",
                        [
                          _c(
                            "TableRow",
                            [
                              _c("TableHeader", [_vm._v("Code Description")]),
                              _c("TableHeader", [_vm._v("Date")]),
                              _c("TableHeader", [_vm._v("Amount")]),
                              _c("TableHeader", [_vm._v("Paid")]),
                              _c("TableHeader", [_vm._v("Balance")]),
                              _c("TableHeader", [_vm._v("Due Now")])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "TableBody",
                        [
                          _c(
                            "TableRow",
                            [
                              _c("TableCell", [_vm._v("OCC Name")]),
                              _c("TableCell", [_vm._v("Spetember 9th, 2018")]),
                              _c("TableCell", [_vm._v("$1,000")]),
                              _c("TableCell", [_vm._v("$1,000")]),
                              _c("TableCell", [_vm._v("0")]),
                              _c("TableCell", [_vm._v("$1,000")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("Box", { attrs: { align: "center", marginTop: 2 } }, [
                    _vm._v(
                      "Please make your check payable to the ou. your contribution is tax deductable."
                    )
                  ]),
                  _c("br"),
                  _c(
                    "Box",
                    { attrs: { display: "flex" } },
                    [
                      _c(
                        "UITable",
                        { staticClass: "small" },
                        [
                          _c(
                            "TableHead",
                            [
                              _c(
                                "TableRow",
                                [
                                  _c("TableHeader", [
                                    _vm._v("Credit Card No.")
                                  ]),
                                  _c("TableHeader", [_vm._v("Expires")]),
                                  _c("TableHeader", [_vm._v("Signature")]),
                                  _c("TableHeader", [_vm._v("Date")])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "TableBody",
                            [
                              _c(
                                "TableRow",
                                [
                                  _c("TableCell", [_vm._v(" ")]),
                                  _c("TableCell", [_vm._v(" ")]),
                                  _c("TableCell", [_vm._v(" ")]),
                                  _c("TableCell", [_vm._v(" ")])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "Box",
                        { staticClass: "enclosed", attrs: { marginLeft: 2 } },
                        [
                          _c("Box", { attrs: { tag: "header" } }, [
                            _vm._v("Amount Enclosed")
                          ]),
                          _c("Box", { staticClass: "field" }, [_vm._v("$")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "Box",
                    { staticClass: "disregard", attrs: { marginTop: 9 } },
                    [
                      _c(
                        "layoutText",
                        {
                          staticClass: "text-center",
                          attrs: { fontWeight: "bold" }
                        },
                        [
                          _vm._v(
                            "If you have already paid your bill, thank you and please disregard this notice."
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("Box", { attrs: { tag: "footer", marginTop: 9 } }, [
                _c("img", {
                  staticClass: "footer-img",
                  attrs: {
                    src:
                      "https://res.cloudinary.com/orthodox-union/image/upload/v1573498550/invoice_footer_xinw7l.png",
                    alt: "OU.org"
                  }
                })
              ])
            ],
            1
          ),
          _vm.showFundraiser
            ? _c(
                "Box",
                {
                  staticClass: "fundraiser",
                  attrs: { flex: 1, marginLeft: 3 }
                },
                [
                  _c(
                    "Card",
                    [
                      _c(
                        "Box",
                        { attrs: { tag: "header", marginBottom: 4 } },
                        [
                          _c("layoutText", { attrs: { fontWeight: "bold" } }, [
                            _vm._v("Select Fundraiser")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "layoutFormRow",
                        { staticClass: "inlineLabel bigger" },
                        [
                          _c("UserLookup", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              value: _vm.state.fundraiserId,
                              clearable: ""
                            },
                            on: { input: _vm.handleFundraiserChange }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }